(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/coupon-id/assets/javascripts/coupon-id-context.js') >= 0) return;  svs.modules.push('/components/tipsen/coupon-id/assets/javascripts/coupon-id-context.js');
"use strict";

const _React = React,
  createContext = _React.createContext;
const CouponIdContext = createContext();
setGlobal('svs.components.tipsen.couponId.CouponIdContext', CouponIdContext);

 })(window);